import React from 'react';
import FAQ from '../components/setting/FAQ';

const FAQPage: React.FC = () => {
  return (
    <div className="main-container">
      <FAQ mode="create" />
    </div>
  );
};

export default FAQPage;
